import { render } from "./DocCard.vue?vue&type=template&id=9f67562a&scoped=true"
import script from "./DocCard.vue?vue&type=script&lang=js"
export * from "./DocCard.vue?vue&type=script&lang=js"

import "./DocCard.vue?vue&type=style&index=0&id=9f67562a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\luis_\\OneDrive\\PAGINAS WEB\\museo-cristal-final\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f67562a"]])

export default __exports__